import { IsMicrophoneHandler, MicrophoneState, ChatState } from "@tt-app/models/exercise";

import { BaseHandler } from "./base";

class MicrophoneHandler extends BaseHandler implements IsMicrophoneHandler {
  getNewState(): MicrophoneState {
    return {
      disabled: false,
      show: false
    };
  }

  loadStateFromChat(chatState: ChatState): MicrophoneState {
    switch (chatState.status) {
      case "MsgBotPlaying":
      case "ProblemDisplaying":
      case "ProblemProcessing":
      case "ProblemFinished":
        return { disabled: true, show: true };
      case "ProblemWaitingForUserAnswer":
        return { disabled: false, show: true };
      case "Initializing":
      case "IntroBotPlaying":
      case "IntroWaitForUser":
      case "ShowTrophy":
      case "Ended":
      default:
        return { disabled: true, show: false };
    }
  }
}

export const microphoneHandler = new MicrophoneHandler();
